<template>
  <div :class="{ bigCard: isBig }" class="card">
    <p class="heading">{{ title }}</p>
    <p class="text">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "PrincipesStage",
  props: {
    title: String,
    text: String,
    isBig: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
@import "src/assets/style/vars"

.card
  width: 333px
  p
    font-size: 16px
    line-height: 24px
  @media (max-width: 600px)
    width: 100%

.bigCard
  width: 100%

.heading
  color: #000
  font-family: 'Inter', sans-serif !important
  font-weight: 700
</style>
